<template>
    <div class="settings">
        <CrmConnectionPendingFinal v-if="!isChange" />
        <template v-else>
            <v-row class="mx-0 my-10">
                <div class="my-6 d-flex align-center">
                    <span>Статус подключения через маркетплейс YCLIENTS: </span>
                    <img v-show="mpConnectionStatusText === 'Не подключено'" class="ml-1 mb-1 mr-1" style="width: 16px; height: 16px;" src="@/assets/icons/error-status.svg" />
                    <img v-show="mpConnectionStatusText === 'Подключено' || mpConnectionStatusText === 'Заморожено'" class="ml-1 mb-1" style="width: 18px; height: 18px;" src="@/assets/icons/success-status.svg" />
                    <span v-if="loading" class="ml-1">Загрузка ...</span>
                    <span v-else>{{ mpConnectionStatusText }}</span>
                </div>
                <BotSettings v-show="isBotSettingsAvailable" :connector="connector" />
            </v-row>
            <v-row justify="end" class="ma-0">
                <v-btn @click="goToProject" outlined class="mr-3 mt-2 cancel-btn">
                    {{ isBotSettingsAvailable ? 'ЗАВЕРШИТЬ' : 'НАЗАД' }}
                </v-btn>
            </v-row>
        </template>
    </div>
</template>

<script>
import BotSettings from './BotSettings.vue'
import CrmConnectionPendingFinal from '@/components/project/onBoarding/CrmConnectionPendingFinal.vue'
import { mapState } from 'vuex'
import cfg from '../../../../config'
import api from '@root/src/api/api'
import { yClientsService } from '@root/src/services/yClients'
export default {
    name: 'YClientsSettingsSimple',
    props: {
        isChange: {
            type: Boolean,
            default: false,
        },
        connector: {
            type: Object,
            default: null,
        },
    },
    components: { BotSettings, CrmConnectionPendingFinal },
    data: () => ({
        cfg,
        mpConnectionStatus: {},
        loading: false,
    }),
    computed: {
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        ...mapState('project', ['loggedAddingConnector']),
        mpConnectionStatusText() {
            return yClientsService.getConnectionStatusText(this.mpConnectionStatus.status)
        },
        isBotSettingsAvailable() {
            return cfg.botYcAvailable.includes(this.project.id)
        },
    },

    methods: {
        goToProject() {
            this.$parent.$emit('goToProject')
        },
    },
    async created() {
        if (this.isChange) {
            this.loading = true
            try {
                const res = await api.connectors.yClients.getConnectionStatus(this.connector.connectorId)
                if (!res.error) {
                    this.mpConnectionStatus = res.data
                } else {
                    this.mpConnectionStatus = { status: 'inactive' }
                }
            } catch (err) {
                this.mpConnectionStatus = { status: 'inactive' }
            } finally {
                this.loading = false
            }
        }
    },
}
</script>
<style lang="sass" scoped>
.settings
    display: flex
    flex-direction: column
.cancel-btn
    border-color: #0000001F !important
</style>
